import moment from "moment";
import {TFunction} from "i18next";
import {IDatePickerStrings} from "@fluentui/react";

export const calendarStrings = (
    t: TFunction,
    m: typeof moment,
): IDatePickerStrings => ({
    closeButtonAriaLabel: t("close") as string,
    days: m.weekdays(),
    goToToday: t("today"),
    months: m.months(),
    shortDays: m.weekdaysShort(),
    shortMonths: m.monthsShort(),
});
